import React from "react";
import { Button } from "./button"

/**
 * ArrayObjectEditor
 * @param {Array} value - Array of objects
 * @param {Function} onChange - Called with new array
 * @param {Array} fields - Array of {key, label, type}
 * @param {String} label - Optional label
 */
export default function ArrayObjectEditor({ value = [], onChange, fields, label }) {
  const handleFieldChange = (idx, key, val) => {
    const newArr = value.map((item, i) =>
      i === idx ? { ...item, [key]: val } : item
    );
    onChange(newArr);
  };
  const handleAdd = () => {
    const empty = {};
    fields.forEach(f => (empty[f.key] = ""));
    onChange([...(value || []), empty]);
  };
  const handleRemove = (idx) => {
    onChange(value.filter((_, i) => i !== idx));
  };

  return (
    <div className="space-y-4">
      {label && <div className="font-semibold mb-2">{label}</div>}
      {(value || []).map((item, idx) => (
        <div key={idx} className="flex gap-2 items-center border p-2 rounded">
          {fields.map((f) => (
            <input
              key={f.key}
              type={f.type || "text"}
              placeholder={f.label}
              value={item[f.key] || ""}
              onChange={e => handleFieldChange(idx, f.key, e.target.value)}
              className="form-input border rounded px-2 py-1 w-32"
            />
          ))}
          <Button
            type="button"
            onClick={() => handleRemove(idx)}
            className="bg-red-600 hover:underline ml-2"
          >
            Eliminar
          </Button>
        </div>
      ))}
      <Button
        type="button"
        onClick={handleAdd}
        className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700"
      >
        Agregar
      </Button>
    </div>
  );
} 